import { DocumentProviderType } from 'models/documentProvider';
import { DocumentOutputFolderRule } from 'models/documentOutputLocation';

/** Where the attachment location of a KPI comes from. Mirrored by numeric value from the API. */
export enum KpiAttachmentLocationSource {
  TenantDefault = 0,
  Override = 1,
}

/**
 * Where the files a user attaches to a KPI question go: the KPI's own category and folder, or the tenant's KPI
 * attachments location with its folder rule. Not bound when neither is set; the user then picks a category.
 */
export default class KpiAttachmentLocation {
  bound: boolean;

  reason?: string;

  source?: KpiAttachmentLocationSource;

  listId?: number;

  listName?: string;

  listUrl?: string;

  providerType?: DocumentProviderType;

  folderRule?: DocumentOutputFolderRule;

  /** The rendered folder name under the tenant category, levels joined with '/'. */
  folderName?: string;

  /** The folder the upload starts in: the KPI's own folder, or with ensure the folder found or created by name. */
  folderDriveItemId?: string;

  folderUrl?: string;

  constructor() {
    this.bound = false;
  }
}

/** A KPI or a task-local question with a category of its own: the override of the tenant's location. */
export class KpiAttachmentOverride {
  kpiId?: number;

  taskTypeFieldId?: number;

  /** The current version of the form a task-local question belongs to; undefined for a KPI. */
  taskTypeId?: number;

  /** The form family of a question, or the owner family of a KPI; undefined for a legacy form or a KPI without one. */
  taskTypeFamilyId?: number;

  name: string;

  formName?: string;

  listId: number;

  listName?: string;

  providerType?: DocumentProviderType;

  folderId?: string;

  folderName?: string;

  constructor() {
    this.name = '';
    this.listId = 0;
  }
}
